export default __webpack_public_path__ + "static/media/uploadVisual.67aee7f3.svg";